/** Shared formatting for the inkooporder screen. Dutch locale throughout. */
export const money = new Intl.NumberFormat('nl-BE', { style: 'currency', currency: 'EUR' });
export const number = new Intl.NumberFormat('nl-BE', { maximumFractionDigits: 2 });

/** Cent-level tolerance, matching the server's totals check. */
export const TOTAL_TOLERANCE = 0.02;

export const inputClass =
  'w-full rounded border border-gray-300 px-2 py-1 text-sm text-td-navy focus:border-td-blue focus:outline-none focus:ring-1 focus:ring-td-blue';
